import styled from "@emotion/styled";
import { TABLET_QUERY_MIN_WIDTH } from "/constants/vp-sizes";
export const StyledBanner = styled.div`
  .desktop-wrapper {
    display: block;
  }

  .mobile-wrapper {
    display: none;
  }

  @media (max-width: ${TABLET_QUERY_MIN_WIDTH}) {
    .desktop-wrapper {
      display: none;
    }

    .mobile-wrapper {
      display: block;
    }
  }
`;
